import { RESET_PAX, RESET_STORE, STORE, TRANSLATE_DATE_FORMAT } from './types';
import { Dispatch } from 'redux';

export const resetStore =
  (whitelist?: STORE[]) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: RESET_STORE,
      payload: { whitelist }
    });
  };

export const resetPax =
  (paxId: number) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: RESET_PAX,
      payload: { paxId }
    });
  };

export const translateDateFormat =
  (dateFormat: string, previousDateFormat: string) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: TRANSLATE_DATE_FORMAT,
      payload: { dateFormat, previousDateFormat }
    });
  };
